import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}

import {nextTick, ref, watch} from 'vue';
import Error from '@/components/Error.vue';
import SelectContactKind from '@/components/SelectContactKind.vue';
import SelectContact from '@/components/SelectContact.vue';
import SelectDispatcher from '@/components/SelectDispatcher.vue';
import CreateBedieners from '@/components/Customer/CreateBedienerComponent.vue';
import router from '@/router';
import {doAlert} from '@/util';
import {postContactHistory, putContactHistory} from '@/api/module/contactHistory';
import {useStorage} from '@/composables/storage';
import ContactHistory, {ApiContactHistoryBedienerSubmitData, ApiContactHistorySubmitData} from '@/model/ContactHistory';
import moment from 'moment';
import {useRoute} from 'vue-router';
import {useSettings} from '@/store/settings';
import {postContactBediener, putContactBediener, deleteContactBediener} from '@/api/module/followup';
import useDetailContactHistoryStore from '@/store/detailContactHistory';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactHistoryCreate',
  setup(__props, { expose: __expose }) {

const store = useDetailContactHistoryStore();
const route = useRoute();
const isEdit = route.params.contact_history_id !== undefined;

useStorage(
    store,
    (contactHistory) => {
      return contactHistory ?
      `Kontakt bearbeiten` :
      'Kontakt anlegen';
    },
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        Nr: parseInt(Array.isArray(route.params.contact_history_id) ? route.params.contact_history_id[0] : route.params.contact_history_id),
      };
    },
);

const contactHistory = ref<ApiContactHistorySubmitData>({
  Art: '',
  Ansprechpartner: [
    {AnsprechpartnerNr: 0},
  ],
  Disponent: null,
  Thema: '',
  Inhalt: '',
});


const Bedieners = ref<Array<ApiContactHistoryBedienerSubmitData & { apiGiven: boolean, changed: boolean }>>([]);
let originalBedieners: Array<ApiContactHistoryBedienerSubmitData & { apiGiven: boolean, changed: boolean }> = [];

const currentTime = moment();
const remainder = 15 - (currentTime.minute() % 15);

// Standard Benutzer aktueller Nutzer / aktuelles Datum
Bedieners.value = [
  {
    Bediener: useSettings().userShort ?? '',
    WiedervorlageDatum: moment().format('YYYY-MM-DD'),
    WiedervorlageUhrzeit: moment(currentTime).add(remainder, 'minutes').format('HH:mm'),
    Erledigt: false,
    Gelesen: false,
    apiGiven: true,
    changed: false,
  },
];

const showResubmission = ref(false);

const loadingSave = ref(false);
const formValid = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

watch(route.query, () => {
  if (route?.query.ansprechpartner_nr) {
    contactHistory.value.Ansprechpartner[0].AnsprechpartnerNr = Number(route.query.ansprechpartner_nr);
  }
}, {immediate: true});

watch(() => store.data, async (data: ContactHistory | null) => {
  if (!isEdit || !data) return;
  contactHistory.value.Art = data.Art ?? '';
  contactHistory.value.Ansprechpartner = data.Ansprechpartner.length > 0 ?
    data.Ansprechpartner.map((partn) => {
      return {AnsprechpartnerNr: partn.AnsprechpartnerNr};
    }) : [];
  contactHistory.value.Disponent = data.Disponent ?? '';
  contactHistory.value.Thema = data.Thema ?? '';
  contactHistory.value.Inhalt = data.Inhalt ?? '';

  Bedieners.value = data.Bediener.map((bed) => ({
    ...bed,
    changed: false,
    WiedervorlageDatum: moment(bed.WiedervorlageDatum).format('YYYY-MM-DD'),
    WiedervorlageUhrzeit: bed.WiedervorlageUhrzeit ? moment(bed.WiedervorlageUhrzeit).format('HH:mm') : null!,
    Gelesen: bed.Gelesen.Status,
    Erledigt: bed.Erledigt.Status,
    apiGiven: true,
  }));
  originalBedieners = data.Bediener.map((bed) => ({
    ...bed,
    changed: false,
    WiedervorlageDatum: moment(bed.WiedervorlageDatum).format('YYYY-MM-DD'),
    WiedervorlageUhrzeit: bed.WiedervorlageUhrzeit ? moment(bed.WiedervorlageUhrzeit).format('HH:mm') : null!,
    Gelesen: bed.Gelesen.Status,
    Erledigt: bed.Erledigt.Status,
    apiGiven: true,
  }));
  await nextTick();
  form.value?.validate();
}, {immediate: true});

watch(
    form, () => {
      form.value?.validate();
    },
);

async function saveBedieners(contactHistory: ContactHistory, isNewContact: boolean) {
  const kundennr = contactHistory.KundenNr;
  const kontaktnr = contactHistory.Nr;
  const operations: Promise<void>[] = [];
  for (const originalBediener of originalBedieners) {
    if (Bedieners.value.some((newBediener) => originalBediener.Bediener === newBediener.Bediener)) continue;
    // delete
    await deleteContactBediener({kundennr, kontaktnr, bediener: originalBediener.Bediener});
  }

  for (const newBediener of Bedieners.value) {
    if (newBediener.Bediener == useSettings().userShort && isNewContact) continue;

    if (originalBedieners.some((originalBediener) => originalBediener.Bediener === newBediener.Bediener)) {
      if (newBediener.changed) {
        // update Bediener
        if (!newBediener.WiedervorlageUhrzeit) {
          newBediener.WiedervorlageUhrzeit = '00:00';
        }
        operations.push(putContactBediener({kundennr, kontaktnr, bediener: newBediener}));
      }
    } else {
      // create
      operations.push(postContactBediener({kundennr, kontaktnr, bediener: newBediener}));
    }
  }

  await Promise.allSettled(operations);
}

async function save() {
  try {
    loadingSave.value = true;
    form.value?.validate();
    if (!formValid.value) {
      throw new Error('Bitte alle Felder korrekt ausfüllen');
    }
    let contactHistoryTemp: ContactHistory;
    let openContactAfterFinish = false;
    // This is a workaround for ios
    const payload = JSON.parse(JSON.stringify(contactHistory.value));
    let isNewContact = false;
    if (store.data && route.params.contact_history_id) {
      contactHistoryTemp = await putContactHistory(Number(route.params.id), Number(route.params.contact_history_id), payload);
    } else {
      contactHistoryTemp = await postContactHistory(Number(route.params.id), payload);
      isNewContact = true;
      openContactAfterFinish = true;
    }

    await saveBedieners(contactHistoryTemp, isNewContact);
    await store.fetch();

    if (openContactAfterFinish) {
      router.push({
        name: 'contact_histories_details',
        params: {
          id: contactHistoryTemp.KundenNr,
          contact_history_id: contactHistoryTemp.Nr,
        },
      });
    } else {
      router.go(-2);
    }
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loadingSave.value = false;
  }
};

function ruleRequired(value: any): true | string {
  if (value) return true;
  if (value === 0) return true;

  return 'erforderlich';
}

function ruleMaxLen(maxLength: number) {
  return (value: any) => !value || String(value).length <= maxLength || `maximal ${maxLength} Zeichen`;
}

__expose({
  contactHistory,
  store,
  form, formValid,
  Bedieners,
  loadingSave,
  showResubmission,
  ruleRequired,
  ruleMaxLen,
  fetch,
  save,
  Error,
  SelectContactKind,
  SelectDispatcher,
  CreateBedieners,
  SelectContact,
});


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!(isEdit && _unref(store).loading) && !_unref(store).error)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValid).value = $event)),
              ref: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(SelectContactKind, {
                  modelValue: contactHistory.value.Art,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactHistory.value.Art) = $event)),
                  "show-label": true,
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(SelectContact, {
                  modelValue: contactHistory.value.Ansprechpartner,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactHistory.value.Ansprechpartner) = $event)),
                  "kunden-nr": Number(_ctx.$route.params.id),
                  "show-label": true,
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "kunden-nr", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contactHistory.value.Thema,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactHistory.value.Thema) = $event)),
                  label: "Thema",
                  rules: [ruleRequired, ruleMaxLen(80)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_textarea, {
                  modelValue: contactHistory.value.Inhalt,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactHistory.value.Inhalt) = $event)),
                  label: "Inhalt"
                }, null, 8, ["modelValue"]),
                _createVNode(SelectDispatcher, {
                  modelValue: contactHistory.value.Disponent,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactHistory.value.Disponent) = $event)),
                  class: "mt-n4 mb-6",
                  "show-label": true
                }, null, 8, ["modelValue"]),
                _createVNode(CreateBedieners, {
                  modelValue: Bedieners.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((Bedieners).value = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value,
                  loading: loadingSave.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Speichern")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "loading"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(Error, {
            key: 1,
            module: _unref(store).$id
          }, null, 8, ["module"]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_overlay, {
      "model-value": loadingSave.value || (isEdit && _unref(store).loading),
      class: "align-center justify-center",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_progress_circular, { indeterminate: "" })
                ]),
                ((isEdit && _unref(store).loading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Kontakt­erfassung wird geladen"))
                  : _createCommentVNode("", true),
                (loadingSave.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Kontakt wird gespeichert"))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})